<div class="warranty-certificate-section" [nbSpinner]="loading()">
  @if (certificates().length > 0) {
    @for (certificate of certificates(); track certificate.id) {
      <div class="certificate-row">
        <div class="certificate-info">
          <nb-icon icon="file-text-outline" class="certificate-icon"></nb-icon>
          <div class="certificate-text">
            <div class="certificate-name">{{ certificate.name }}</div>
            @if (certificate.manufacturer) {
              <div class="certificate-sub">{{ certificate.manufacturer }}</div>
            }
          </div>
          <nb-tag
            size="tiny"
            [status]="statusTagStatus(certificate.status)"
            [text]="certificate.status"
          ></nb-tag>
        </div>
        <div class="certificate-actions">
          @if (certificate.pdfAttachmentURL) {
            <a
              nbButton
              size="tiny"
              status="primary"
              ghost
              [href]="certificate.pdfAttachmentURL"
              target="_blank"
              rel="noopener"
            >
              <nb-icon icon="external-link-outline"></nb-icon>
              See Warranty Certificate
            </a>
          }
        </div>
      </div>
      @if (certificate.aiSummary) {
        <details class="certificate-summary">
          <summary>AI Coverage Summary</summary>
          <pre>{{ certificate.aiSummary }}</pre>
        </details>
      }
    }
    <div class="upload-row">
      <button nbButton size="tiny" ghost status="basic" (click)="openUploadDialog()">
        <nb-icon icon="upload-outline"></nb-icon>
        Upload another certificate for this unit
      </button>
    </div>
  } @else if (!loading()) {
    <div class="empty-state">
      <div class="empty-text">No warranty certificate on file for this unit.</div>
      <button nbButton size="small" status="primary" (click)="openUploadDialog()">
        <nb-icon icon="upload-outline"></nb-icon>
        Upload Warranty Certificate
      </button>
    </div>
  }
</div>

<ng-template #uploadDialog let-ref="dialogRef">
  <nb-card class="upload-dialog">
    <nb-card-header>Upload Warranty Certificate</nb-card-header>
    <nb-card-body>
      <div class="mb-2">
        <label class="label" for="warranty-cert-name">Certificate Name</label>
        <input
          id="warranty-cert-name"
          nbInput
          fullWidth
          fieldSize="small"
          [ngModel]="certificateName()"
          (ngModelChange)="certificateName.set($event)"
          placeholder="e.g. Toyota 2025 Class III Warranty"
        />
      </div>
      <div class="mb-2">
        <label class="label" for="warranty-cert-section-file">
          Certificate PDF
        </label>
        <input
          id="warranty-cert-section-file"
          type="file"
          accept=".pdf"
          (change)="onFileSelected($event)"
        />
      </div>
      @if (selectedFile(); as file) {
        <div class="selected-file">
          {{ file.name }} ({{ fileSizeMB(file) }} MB)
        </div>
      }
      <div class="hint">
        The certificate is associated directly to this unit. An AI coverage
        summary is generated automatically after upload.
      </div>
    </nb-card-body>
    <nb-card-footer class="dialog-footer">
      <button nbButton size="small" ghost status="basic" (click)="ref.close()">
        Cancel
      </button>
      <button
        nbButton
        size="small"
        status="primary"
        [disabled]="!selectedFile() || !certificateName().trim() || uploading()"
        [nbSpinner]="uploading()"
        (click)="uploadCertificate(ref)"
      >
        Upload
      </button>
    </nb-card-footer>
  </nb-card>
</ng-template>
